export default "__VITE_ASSET__BhJ8WjTL__"